<template>
  <div class="row">
    <LoadingContentPanel :isLoadShow="isLoadShow"/>
    <CreateStaff v-if="staffCase === 'create'"></CreateStaff>
    <OrderList v-if="staffCase === 'list'" :userId="this.$store.state.userId" userType="staff"></OrderList>
    <CurrentOrder v-if="staffCase === 'info'" :userId="this.$store.state.userId" userType="staff" :orderId="this.routeInfo.id"></CurrentOrder>
    <TimeInfo v-if="staffCase === 'time'" :userId="this.$store.state.userId" category="staff" :orderId="this.routeInfo.id" parentType="staff"></TimeInfo>
    <AccountInfo v-if="staffCase === 'account'" :userId="this.$store.state.userId" userType="staff"></AccountInfo>
    <AccountOrderWrap v-if="staffCase === 'accountOrder'" :lineId="this.$store.state.userId" userType="staff"></AccountOrderWrap>
  </div>
</template>
<script>
import LoadingContentPanel from '@/components/utils/LoadingContentPanel.vue'
import CreateStaff from '@/components/CreateStaff.vue'
import OrderList from '@/components/OrderList.vue'
import CurrentOrder from '@/components/CurrentOrder.vue'
import TimeInfo from '@/components/TimeInfo.vue'
import AccountInfo from '@/components/AccountInfo.vue'
import AccountOrderWrap from '@/components/AccountOrderWrap.vue'

export default {
  name: 'StaffView',
  data () {
    return {
      routeInfo: {
        type: '',
        category: '',
        case: '',
        id: ''
      },
      isStaff: false,
      isCheck: false,
      isList: false,
      isCurrentOrder: false,
      staffCase: '',
      isLoadShow: true
    }
  },
  created () {
    this.$nextTick(() => {
      this.checkIsStaff()
    })
  },
  watch: {
    '$store.state.userId' () {
      this.checkIsStaff()
    }
  },
  methods: {
    checkIsStaff () {
      const self = this
      const userId = this.$store.getters.getUserId
      const getStatusUrl = this.$apiDoc.staffUrl + userId + this.$apiDoc.apiCheckStaffVaild
      if (userId) {
        this.$api.get(getStatusUrl, {}).then((resp) => {
          if (resp.result) {
            // alert(userId)
            // alert(resp.data)
            switch (resp.data) {
              case '已認證':
                self.isStaff = true
                break
              case '認證中':
                self.isCheck = true
                break
            }
          }
          self.updateRender()
        }).catch((errorInfo) => {
          console.log('errorInfo:', errorInfo)
          self.forceCreateStaffender()
        })
      }
    },
    checkRenderCategoryPanel () {
      switch (this.routeInfo.category) {
        case 'users':
          this.checkUserCase()
          break
        case 'orders':
          this.checkOrderCase()
          break
        case 'account':
          this.checkAccountCase()
          break
        default:
          this.staffCase = ''
          this.isLoadShow = true
      }
      // alert('this.staffCase:' + this.staffCase)
      this.$forceUpdate()
    },
    checkUserCase () {
      switch (this.routeInfo.case) {
        case 'create':
          if (this.isStaff) {
            alert('您已經是我們的夥伴，無須重新申請!')
            this.$liff.closeWindow()
          } else {
            if (this.isCheck) {
              alert('很抱歉，您的身分還在驗證中，請靜候通知。')
              this.$liff.closeWindow()
            } else {
              this.staffCase = 'create'
              this.isLoadShow = false
            }
          }
          break
      }
    },
    checkOrderCase () {
      switch (this.routeInfo.case) {
        case 'house':
          this.staffCase = 'houseCheck'
          this.isLoadShow = false
          break
        case 'list':
          this.staffCase = 'list'
          this.isLoadShow = false
          break
        case 'info':
          this.staffCase = 'info'
          this.isLoadShow = false
          break
        case 'time':
          this.staffCase = 'time'
          this.isLoadShow = false
          break
      }
    },
    checkAccountCase () {
      switch (this.routeInfo.case) {
        case 'customer':
        case 'staff':
          this.isLoadShow = false
          this.staffCase = 'account'
          break
        case 'orderinfo':
          this.staffCase = 'accountOrder'
          break
      }
    },
    updateRender () {
      const currentFpt = this.$route.fullPath
      var tranPtArray = currentFpt.split('/').slice(1) // eg. ['staff', 'user', 'create']
      var currenRouteInfo = this.$store.getters.getRouteInfo
      var caseIdArray = []
      if (this.isStaff) {
        if (tranPtArray[2]) {
          tranPtArray[2] = tranPtArray[2].includes('?v') ? tranPtArray[2].split('?v').shift() : tranPtArray[2]
        }
        if (tranPtArray.length > 2 && (currenRouteInfo.category !== tranPtArray[1] || currenRouteInfo.case !== tranPtArray[2])) {
          this.routeInfo.type = tranPtArray[0].includes('?') ? tranPtArray[0].split('?').shift() : tranPtArray[0]
          this.routeInfo.category = tranPtArray[1]
          if (tranPtArray[2] && tranPtArray[2].includes('#')) {
            caseIdArray = tranPtArray[2].split('#')
            this.routeInfo.case = caseIdArray[0]
            this.routeInfo.id = caseIdArray[1]
          } else {
            this.routeInfo.case = tranPtArray[2]
          }
          this.$store.dispatch('setRouteInfo', this.routeInfo)
        } else {
          this.routeInfo = currenRouteInfo
        }
        this.checkRenderCategoryPanel()
      } else {
        if (this.isCheck) {
          alert('很抱歉，您的身分還在驗證中，請靜候通知再執行相關操作')
          this.$liff.closeWindow()
        } else {
          this.forceCreateStaffender()
        }
      }
    },
    forceCreateStaffender () {
      this.staffCase = 'create'
      this.isLoadShow = false
      this.$forceUpdate()
    }
  },
  components: {
    LoadingContentPanel,
    CreateStaff,
    OrderList,
    CurrentOrder,
    TimeInfo,
    AccountInfo,
    AccountOrderWrap
  }
}
</script>
